export default {
  GET_FEATURES: 'GET_FEATURES',
  GET_CATEGORIES: 'GET_CATEGORIES',
  GET_VERSIONS: 'GET_VERSIONS',
  GET_TAGS: 'GET_TAGS',
  GET_FEATURES_BY_VERSIONS: 'GET_FEATURES_BY_VERSIONS',
  FILTER_FEATURES_BY_CATEGORIES: 'FILTER_FEATURES_BY_CATEGORIES',
  FILTER_FEATURES_BY_VERSIONS: 'FILTER_FEATURES_BY_VERSIONS',
  FILTER_FEATURES_BY_TAGS: 'FILTER_FEATURES_BY_TAGS',
  FILTER_FEATURES_BY_SEARCH: 'FILTER_FEATURES_BY_SEARCH',
  ADD_FEATURE: 'ADD_FEATURE',
  UPDATE_FEATURE: 'UPDATE_FEATURE',
  DELETE_FEATURE: 'DELETE_FEATURE',
};
